// src/components/routing/ProtectedRoute.jsx
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const API_BASE = import.meta.env.VITE_API_BASE || "http://localhost:8080";

const ProtectedRoute = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem("authToken");

      if (!token) {
        setIsAuthorized(false);
        return;
      }

      // Try to verify token by hitting a protected endpoint
      let response = await fetch(`${API_BASE}/api/profile`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // If expired, try to refresh
      if (response.status === 401) {
        const refreshToken = localStorage.getItem("authRefreshToken");

        if (refreshToken) {
          const refreshRes = await fetch(`${API_BASE}/auth/refresh`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refreshToken }),
          });

          if (refreshRes.ok) {
            const resp = await refreshRes.json();
            localStorage.setItem("authToken", resp.tokens.access.token);
            localStorage.setItem("authRefreshToken", resp.tokens.refresh.token);

            response = await fetch(`${API_BASE}/api/profile`, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${resp.tokens.access.token}`,
              },
            });

            if (response.ok) {
              setIsAuthorized(true);
              return;
            }
          }
        }

        // If token can't be refreshed or still invalid
        localStorage.removeItem("authToken");
        localStorage.removeItem("authRefreshToken");
        setIsAuthorized(false);
        return;
      }

      if (response.ok) {
        setIsAuthorized(true);
      } else {
        setIsAuthorized(false);
      }
    };

    verifyToken();
  }, []);

  if (isAuthorized === null) return null; // Or loading spinner

  if (!isAuthorized) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;